// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"25f0b07a","374":"ca243fb6","429":"0b4f534c","432":"99a0eb3c","453":"6c59375b","507":"09f390c8","696":"c82745ed"}[chunkId] + ".chunk.js";
};